module.exports = __webpack_public_path__ + "img/1135688404.906fe95d.jpg";